import React from "react";
import "./RecommendationChannels.css";

const formatMargin = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  const number = Number(value);
  return Number.isFinite(number)
    ? `${number.toLocaleString(undefined, { maximumFractionDigits: 2 })}%`
    : "-";
};

const RecommendationChannels = ({ marketplaces }) => {
  const partners = Array.isArray(marketplaces) ? marketplaces : [];
  if (partners.length === 0) return null;

  return (
    <section className="recommendation-marketplaces mb-4">
      <div className="mb-3">
        <h6 className="font-weight-bold mb-1">Selected Marketplaces</h6>
        <div className="text-muted small">Profit margin by partner</div>
      </div>
          <div className="recommendation-marketplaces-grid">
            {partners.map((partner, index) => (
              <div className="recommendation-marketplace-tile" key={partner.partner_id ?? index}>
                  <span className="recommendation-marketplace-avatar" aria-hidden="true">
                    {(partner.partner_name || "M").slice(0, 1).toUpperCase()}
                  </span>
                  <div className="recommendation-marketplace-name">{partner.partner_name || "Marketplace"}</div>
                  <div className="recommendation-marketplace-margin">
                    {formatMargin(partner.profit_margin_percentage)}
                    <span>profit margin</span>
                  </div>
              </div>
            ))}
          </div>
    </section>
  );
};

export default RecommendationChannels;
